import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import {
  FaShoppingCart,
  FaFacebookSquare,
  FaInstagramSquare,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
import { FiDownloadCloud } from "react-icons/fi";

function Home({ baseURL }) {
  const [view, setView] = useState(0);
  const [viewProgram, setViewProgram] = useState(false);
  const [program, setProgram] = useState({});
  const [items, setItems] = useState([]);
  const [licenses, setLicenses] = useState([]);

  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const sendUrlParam = (name, value) => {
    query.set(name, value); // Cambia o agrega ?id=nuevoValor
    navigate(`/?${query.toString()}`);
  };

  const programId = query.get("id");

  // Cargar elemento
  useEffect(() => {
    fetch(`${baseURL}/posts/${programId}`)
      .then((res) => res.json())
      .then((data) => {
        setProgram(data);
      })
      .catch(console.error);
  }, [items]);

  //Cargar Licencias
  useEffect(() => {
    fetch(baseURL + "/licenses")
      .then((res) => res.json())
      .then((data) => {
        setLicenses(data);
      })
      .catch(console.error);
  }, []);

  return (
    <>
      <div>
        
        <nav className="main-nav" id="main-nav">
          <p onClick={() => {sendUrlParam("view", 0)}}>Inicio</p>
          <p onClick={() => {sendUrlParam("view", 1)}}>Programas</p>
          <p onClick={() => {sendUrlParam("view", 2)}}>Acerca de</p>
          <p onClick={() => {sendUrlParam("view", 3)}}>Contáctenos</p>
          <p onClick={() => {sendUrlParam("view", 4)}}>Ayuda</p>
          <p onClick={() => {sendUrlParam("view", 5)}}>Tutoriales</p>
          <p onClick={() => {sendUrlParam("view", 6)}}>Màs</p>
        </nav>
        <section className="g-section" id="program-details">
          <div className="program-detail">
            <h2>{program.name}</h2>
            <img src={program.image} alt="programImg" draggable={false} />
            <div
              className="rendered-content"
              dangerouslySetInnerHTML={{ __html: program.content }}
            ></div>
            {program.videoUrl && (
              <>
                <h3>Video Tutorial</h3>
                <iframe src={program.videoUrl} frameborder="0"></iframe>
              </>
            )}
            <button onClick={() => window.open(program.links)}>
              <FiDownloadCloud />
              Descargar
            </button>
          </div>
          <div className="program-detail-licenses">
            {licenses.length > 0 && (
              <section className="g-section" id="section-licenses">
                <div className="licenses-grid">
                  {licenses.map((license, index) =>
                    index < 4 ? (
                      <article>
                        <h2>{license.name}</h2>
                        <p>{license.description} </p>
                        <ul>
                          {license.features.map((feature, index) => (
                            <>
                              <li>{feature}</li>
                            </>
                          ))}
                        </ul>
                        <button onClick={() => window.open(license.link)}>
                          <FaShoppingCart />
                        </button>
                      </article>
                    ) : null
                  )}
                </div>
              </section>
            )}
          </div>
        </section>
      </div>

      <footer>
        <div className="container">
          <section className="sect-0">
            <h3>Información</h3>
            <a href="#hero" onClick={() => {sendUrlParam("view", 0)}}>Inicio</a>
            <a href="#section-licenses" onClick={() => {sendUrlParam("view", 3)}}>Contacto</a>
            <a href="#start-programs" onClick={() => {sendUrlParam("view", 1)}}>Programas</a>
          </section>

          <hr />
          <br />

          <a
            href="https://bsitescomp.com"
            target="_blank"
            rel="noreferrer noopener"
            className="copyright"
          >
            &copy; 2025 Web Develop by <strong>B‑Sites</strong>
          </a>
        </div>
      </footer>
    </>
  );
}

export default Home;
